import React from 'react';

import { Box, Grid, Stack, Typography } from '@mui/material';
import { ButtonWithIcon } from 'src/v2/components/ui/buttons/buttonWithIcon';
import { VestaIcon, VestaPartnerIcons } from 'src/v2/components/ui/icons/vesta';

import { primaryColors } from '~components/theme/styles/colors';
import { secondaryBox } from '~components/theme/styles/mixins';

import SlideWrapper from '../SlideWrapper';

function IntegratedPartnersSlide() {
  return (
    <SlideWrapper
      sx={{
        justifyContent: 'center',
        overflow: 'hidden',
      }}
    >
      <Typography textAlign={{ xs: 'center', sm: 'left' }} variant={'h4'}>
        Experience the power of VST through our integrated partners
      </Typography>
      <Grid container direction={'row'} spacing={4} mt={4}>
        <Grid item xs={12} sm={6}>
          <Box sx={secondaryBox}>
            <Stack direction={'row'} spacing={2} alignItems={'center'}>
              <VestaIcon size={64} icon={VestaPartnerIcons.RADIANT} noBg noBorder />
              <Typography variant="h5" color={primaryColors[100]}>
                Radiant Capital
              </Typography>
            </Stack>
            <Typography variant="body1" mt={2} color={primaryColors[100]}>
              Deposit your VST on Radiant
            </Typography>
            <ButtonWithIcon variant={'secondary'} iconSize={16} iconType="arrow" sx={{ mt: 4 }}>
              VISIT RADIANT
            </ButtonWithIcon>
          </Box>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Box sx={secondaryBox}>
            <Stack direction={'row'} spacing={2} alignItems={'center'}>
              <VestaIcon size={64} icon={VestaPartnerIcons.RADIANT} noBg noBorder />
              <Typography variant="h5" color={primaryColors[100]}>
                Arable Finance
              </Typography>
            </Stack>
            <Typography variant="body1" mt={2} color={primaryColors[100]}>
              Deposit you VST on Arable
            </Typography>
            <ButtonWithIcon variant={'secondary'} iconSize={16} iconType="arrow" sx={{ mt: 4 }}>
              VISIT ARABLE
            </ButtonWithIcon>
          </Box>
        </Grid>
      </Grid>
    </SlideWrapper>
  );
}

export default IntegratedPartnersSlide;
